{
  "settings": {
    "title": "Настройки аккаунта",
    "subtitle": "Управляйте электронной почтой, паролем и статусом аккаунта.",
    "needHelp": "Нужна помощь? Присоединяйтесь к нашему Discord"
  },
  "changeEmail": {
    "title": "Изменить адрес электронной почты",
    "subtitle": "Изменение email потребует повторного подтверждения адреса. Вы будете выйдены из всех сессий.",
    "newEmailLabel": "Новый адрес электронной почты",
    "newEmailPlaceholder": "Введите новый email",
    "currentPasswordLabel": "Текущий пароль",
    "currentPasswordPlaceholder": "Введите текущий пароль",
    "submitButton": "Обновить адрес электронной почты",
    "submittingButton": "Обновление..."
  },
  "changePassword": {
    "title": "Изменить пароль",
    "subtitle": "Обновите ваш пароль. Вы останетесь в системе на этом устройстве.",
    "currentPasswordLabel": "Текущий пароль",
    "currentPasswordPlaceholder": "Введите текущий пароль",
    "newPasswordLabel": "Новый пароль",
    "newPasswordPlaceholder": "Введите новый пароль",
    "confirmPasswordLabel": "Подтвердите новый пароль",
    "confirmPasswordPlaceholder": "Подтвердите новый пароль",
    "submitButton": "Изменить пароль",
    "submittingButton": "Обновление..."
  },
  "closeAccount": {
    "title": "Закрыть аккаунт",
    "subtitle": "Окончательно деактивируйте свой аккаунт. Если у вас есть активная подписка, она будет отменена. Это действие нельзя легко отменить.",
    "openButton": "Я хочу закрыть свой аккаунт",
    "warning": "⚠️ Внимание: это деактивирует ваш аккаунт, отменит все активные подписки, выйдет из всех сессий. Возврат средств за отменённые подписки не производится. Ваши данные будут сохранены, но аккаунт станет недоступным.",
    "passwordLabel": "Ваш пароль",
    "passwordPlaceholder": "Введите ваш пароль",
    "confirmLabel": "Введите",
    "confirmCode": "ЗАКРЫТЬ МОЙ АККАУНТ",
    "confirmLabelEnd": "для подтверждения",
    "confirmPlaceholder": "ЗАКРЫТЬ МОЙ АККАУНТ",
    "cancelButton": "Отмена",
    "submitButton": "Закрыть аккаунт навсегда",
    "submittingButton": "Закрытие..."
  },
  "contactUs": {
    "title": "Связаться с нами",
    "body": "Свяжитесь с нами по адресу",
    "discordName": "Flipping Pal Discord",
    "bodyEnd": "или присоединяйтесь к нашему Discord-сообществу, если у вас есть вопросы."
  }
}
